import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import ApprovalMonitorListContainer from '../../containers/approval_monitoring/ApprovalMonitorListContainer';
import ApprovalV2MonitorContainer from '../../containers/approval/ApprovalV2MonitorContainer';
import * as approvalV2Api from '../../lib/api/approvalV2';

// 2026-10-20 결재 V2 이관 후속(4절 과제): 결재 모니터링이 V1(COM_APPR_DET)만 보여주던
// 공백을 "V2" 탭으로 메웠다 - V1/V2 문서가 서로 다른 테이블이라 한 목록으로 합치지 않고
// 결재함(V1/V2, ApprovalMngPage)과 같은 탭 분리 방식을 그대로 썼다(이 Tabs 위에 두고
// 아래에 해당 화면을 그대로 렌더 - 각 화면이 자기 BreadcrumbsContainer를 그대로 유지).
// V2 탭은 전결 권한 관리와 같은 권한(canManage)이 있는 사람에게만 보인다 - 전체 조회라
// 아무나 볼 자료가 아님.
const ApprovalMonitorListPage = () => {
  const [tab, setTab] = useState('v1');
  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    approvalV2Api
      .getApprovalV2AuthManagePermission()
      .then((res) => setCanManage(Boolean(res?.data?.canManage)))
      .catch(() => setCanManage(false));
  }, []);

  return (
    <Box>
      {canManage && (
        <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 1 }}>
          <Tab value="v1" label="결재 모니터링" />
          <Tab value="v2" label="결재 모니터링(V2)" />
        </Tabs>
      )}
      {tab === 'v2' && canManage ? (
        <ApprovalV2MonitorContainer />
      ) : (
        <ApprovalMonitorListContainer />
      )}
    </Box>
  );
};

export default ApprovalMonitorListPage;
